import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarBlank } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/format";

export const SnapshotSelector = ({ snapshots, value, onChange }) => {
  if (!snapshots || snapshots.length === 0) return null;
  return (
    <div className="flex items-center gap-2">
      <CalendarBlank size={16} weight="bold" className="text-[#64748B]" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          data-testid="snapshot-selector"
          className="h-9 w-48 rounded-sm border-[#E3E7EC] bg-[#F1F3F6] text-sm text-[#0F172A] focus:ring-[#F0323E]"
        >
          <SelectValue placeholder="Snapshot" />
        </SelectTrigger>
        <SelectContent className="max-h-72 rounded-sm border-[#E3E7EC] bg-[#FFFFFF] text-[#0F172A]">
          {snapshots.map((s, i) => (
            <SelectItem key={s.id} value={s.id} className="text-sm" data-testid={`snapshot-option-${i}`}>
              {fmtDate(s.reference_date)}{i === 0 ? " · latest" : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
